export default "__VITE_ASSET__DnwbGdIX__ 584w";